import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  LinearProgress,
  useMediaQuery,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ArrowForward } from "@material-ui/icons";
import { FormBuilder } from "@zennya/web-component-library/src/components/FormBuilder";
import { ConcentricBadge } from "components/ConcentricBadge";
import { motion } from "framer-motion";
import { debounce, isEmpty } from "lodash";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { JsonParam, StringParam } from "serialize-query-params";
import { BooleanParam, useQueryParam } from "use-query-params";
import { processHealthPass } from "util/ProcessHealthPass";
import { slideRight, slideUp } from "util/transitions";
import * as Yup from "yup";
import { useStyles as baseCardStyles } from "../MedicalId/index";

const useStyles = makeStyles((theme) => ({}));

const formLayout = ["identityType", "corporateIdNumber"];

function CorporateIdLinking() {
  const classes = { ...useStyles(), ...baseCardStyles() };
  const history = useHistory();
  const location = useLocation();

  const [urlFormValues, setUrlFormValues] = useQueryParam(
    "linkIdForm",
    JsonParam
  );
  const [isDependent, setIsDependent] = useQueryParam(
    "isDependent",
    BooleanParam
  );

  const [formValues, setFormValues] = useState(urlFormValues);

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("xs"), {
    noSsr: true,
  });

  const backButtonProps = {
    variant: isMobile ? "text" : "contained",
  };

  const debounceParams = useCallback(
    debounce(
      (values) => {
        setUrlFormValues(values, "replaceIn");
      },
      250,
      { maxWait: 500 }
    ),
    []
  );

  useEffect(() => {
    debounceParams(formValues);
  }, [debounceParams, formValues, setUrlFormValues]);

  const form = useMemo(() => {
    return {
      corporateIdNumber: {
        type: "text",
        label: "Input Corporate ID Number",
        initialValues: formValues?.corporateIdNumber ?? "",
        validator: () => Yup.string().required().nullable().label(" "),
        readOnly: formValues?.corporateIdNumber,
        fieldProps: {
          className: formValues?.corporateIdNumber
            ? classes.prefilled
            : classes.default,
        },
      },
      identityType: {
        type: "select",
        label: "Identity Type",
        initialValues: formValues?.identityType ?? "",
        options: [
          { value: "EMPLOYEE", label: "Employee" },
          { value: "DEPENDENT", label: "Dependent" },
          { value: "EXTERNAL", label: "Third Party" },
        ],
        settings: {
          default: "",
          multiple: false,
          labelField: "label",
          valueField: "value",
        },
        readOnly: formValues?.identityType,
        fieldProps: {
          className: formValues?.identityType
            ? classes.prefilled
            : classes.default,
        },
        validator: () => Yup.string().required().nullable().label(" "),
      },
    };
  }, [
    classes.default,
    classes.prefilled,
    formValues?.corporateIdNumber,
    formValues?.identityType,
  ]);

  async function handleSubmit() {
    history.push({
      pathname: isDependent?"/onboarding/dependent":"/onboarding/basicinfo",
      search: location.search,
    });
  }

  return (
    <Container fixed maxWidth="md" className={classes.cardInset}>
      <Box className={classes.headerContainer}>
        <ConcentricBadge number="2" />
        <span className={classes.header}>Corporate ID Linking</span>
      </Box>
      <Card className={classes.card}>
        <CardContent>
          <FormBuilder
            formId="linkId"
            // usePersist
            onChange={(values) => {
              setFormValues(values);
            }}
            variant="outlined"
            formLabel=" "
            submitLabel={
              <>
                Next <ArrowForward fontSize="small" />
              </>
            }
            formFactor="default"
            hasReset={false}
            formLayout={formLayout}
            form={form}
            onSubmit={(values) => {
              console.log("📢[index.js:101 form submit]:", values);
              handleSubmit();
            }}
            additionalActions={() => (
              <Button
                {...backButtonProps}
                onClick={() => {
                  history.goBack();
                }}
              >
                Back
              </Button>
            )}
          />
        </CardContent>
      </Card>
    </Container>
  );
}

export default function CorporateIdLinkingLoader() {
  const [loading, setLoading] = useState(true);
  const [hashId, setHashId] = useQueryParam("code", StringParam);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("xs"), {
    noSsr: true,
  });
  const [urlFormValues, setUrlFormValues] = useQueryParam(
    "linkIdForm",
    JsonParam
  );
  const [isDependent, setIsDependent] = useQueryParam(
    "isDependent",
    BooleanParam
  );

  useEffect(() => {
    async function fetchHealthPass() {
      if (isEmpty(urlFormValues)) {
        const healthPass = await processHealthPass(hashId);
        setIsDependent(healthPass?.dependentDetails?.isDependent, "replaceIn");
        setUrlFormValues(healthPass?.linkIdForm, "replaceIn");
      }
      setLoading(false);
    }
    fetchHealthPass();
  }, [hashId, setUrlFormValues]);

  if (loading) {
    return <LinearProgress />;
  }
  return (
    <motion.div {...(isMobile ? slideRight : slideUp)}>
      <CorporateIdLinking />
    </motion.div>
  );
}
